
<template>
  <BliModal
    :active="isModalVisible && !isFirstVisitCompleted"
    width="medium"
  >
    <BliModalBody>
      <div class="status-modal">
        <img
          :src="modalDetails.imageSrc"
          alt="icon"
        >
        <div class="body">
          <div class="card">
            <div class="card_title">
              {{ modalDetails.title }}
            </div>
            <div class="card_description">
              {{ modalDetails.description }}
            </div>
          </div>
          <div class="helper">
            <BliIconSiUspCustomerCare
              height="18px"
              width="18px"
              class="helper_icon"
            />
            <div class="helper_content">
              {{ modalDetails.helperText }}
            </div>
          </div>
        </div>
      </div>
    </BliModalBody>
    <BliModalFooter>
      <BliButton
        full-width
        :loading="showButtonLoader"
        @click="handleAction"
      >
        {{ modalDetails.button }}
      </BliButton>
    </BliModalFooter>
  </BliModal>
</template>
<script src="./index.js"></script>
  <style lang="scss" scoped>
  html:not([dark]) {
    @import '@blibli/blue-design-tokens/dist/tokens-default.scss';
    @import './index.scss';
  }
  html[dark] {
    @import '@blibli/blue-design-tokens/dist/tokens-dark.scss';
    @import './index.scss';
  }
  </style>
